import { render } from "./newpages.vue?vue&type=template&id=14df280f&scoped=true"
import script from "./newpages.vue?vue&type=script&lang=js"
export * from "./newpages.vue?vue&type=script&lang=js"

import "./newpages.less?vue&type=style&index=0&id=14df280f&lang=less&scoped=true"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14df280f"]])

export default __exports__